import module from './module.js'
// Components
import './components/component.js'
import './components/cargarmovimientos/component.js'
import './components/cargarmovimientos/configuracion/component.js'
import './components/cargarmovimientos/confirmar/component.js'
import './components/cargarmovimientos/decodificador/component.js'
import './components/cargarmovimientos/item/component.js'
import './components/cargarmovimientos/item/opcion/component.js'
import './components/cargarmovimientos/registros/component.js'
import './components/comparativaSuaNomina/component.js'
import './components/comparativaSuaNomina/exportar/component.js'
import './components/comparativaSuaNomina/lista/component.js'
import './components/comparativaSuaNomina/lista/item/component.js'
import './components/comparativaSuaNomina/lista/item/validacion/component.js'
import './components/dictamen/colaboradores/component.js'
import './components/dictamen/incidencias/component.js'
import './components/dictamen/incidencias/lista/component.js'
import './components/dictamen/puestos/component.js'
import './components/directorio/component.js'
import './components/directorio/contacto/component.js'
import './components/pagossua/component.js'
import './components/pagossua/archivo/component.js'
import './components/pagossua/confirmar/component.js'
import './components/pagossua/historial/component.js'
import './components/pagossua/lista/component.js'
import './components/pagossua/lista/agrupacion/component.js'
import './components/pagossua/lista/item/component.js'
import './components/pagossua/mensaje/component.js'
import './components/reportes/incapacidades/component.js'
import './components/reportes/incapacidades/exportar/component.js'
import './components/reportes/incapacidades/item/component.js'
import './components/reportes/retencion/infonavit/component.js'
import './components/reportes/retencion/infonavit/descarga/component.js'
import './components/reportes/retencion/infonavit/item/component.js'
import './components/visorlotes/component.js'
import './components/visorlotes/configuracion/component.js'
import './components/visorlotes/descargas/sua/component.js'
import './components/visorlotes/lista/component.js'
import './components/visorlotes/lista/item/component.js'
import './components/visorlotes/lote/component.js'
import './components/visorlotes/lote/eliminar/component.js'
import './components/visorlotes/lote/validacion/component.js'
// Routes
import './routes/recursoshumanos.js'
import './routes/recursoshumanos/cargarMovimientos.js'
import './routes/recursoshumanos/cargarPagos.js'
import './routes/recursoshumanos/cargarPagos/historial.js'
import './routes/recursoshumanos/comparativaSuaNomina.js'
import './routes/recursoshumanos/dictamen.js'
import './routes/recursoshumanos/dictamen/colaboradores.js'
import './routes/recursoshumanos/dictamen/incidencias.js'
import './routes/recursoshumanos/dictamen/puestos.js'
import './routes/recursoshumanos/directorio.js'
import './routes/recursoshumanos/reporteRetencionInfonavit.js'
import './routes/recursoshumanos/reportesIncapacidades.js'
import './routes/recursoshumanos/visorLotes.js'
// Services
import './services/ClasePrimaDeRiesgo.js'
import './services/ClasePrimaDeRiesgo/RegistrosPatronales'
import './services/Operadoras.js'
import './services/RecursoshumanosSUA.js'
import './services/RegistroPatronal.js'
import './services/RecursosHumanos/Comparativasuanomina.js'
import './services/RecursosHumanos/Comparativasuanomina/Reporte.js'
import './services/RecursosHumanos/Dictamen/Colaboradores.js'
import './services/RecursosHumanos/Dictamen/Incidencias.js'
import './services/RecursosHumanos/Dictamen/Puestos.js'
import './services/RecursosHumanos/Directorio.js'
import './services/RecursosHumanos/Empresas.js'
import './services/RecursosHumanos/Empresa/Proyectos.js'
import './services/RecursosHumanos/LotesIMSS.js'
import './services/RecursosHumanos/LotesIMSS/Coincidencias.js'
import './services/RecursosHumanos/LotesIMSS/Existe.js'
import './services/RecursosHumanos/PagosSua.js'
import './services/RecursosHumanos/PagosSua/Historial.js'
import './services/RecursosHumanos/Reportes/Incapacidades.js'
import './services/RecursosHumanos/Reportes/RetencionInfonavit.js'
import './services/RecursosHumanos/VisorLotes.js'
import './services/RecursosHumanos/VisorLotes/Lote.js'
import './services/VisorLotesService.js'

export default module.name



// WEBPACK FOOTER //
// ./src/recursoshumanos/index.js